<script lang="ts" setup>
// import Product from "@/models/Product";
import { notify } from "@kyvg/vue3-notification";
import { ref } from "vue";

// const props = defineProps<{ product: Product }>();
const sharing = ref(false);

const shareLink = async () => {
  const url = window.location.href; // Enlace actual
  const title = document.title; // Título de la página
  let notifTitle = "";
  let notifError = false;

  if (navigator.share) {
    sharing.value = true;
    try {
      await navigator.share({ title, url });
      notifTitle = "¡Enlace compartido exitosamente!";
    } catch (error) {
      notifError = true;
      console.error(error);
    } finally {
      sharing.value = false;
    }
  } else {
    notifTitle =
      "La función para compartir no está disponible en este navegador.";
  }
  if (notifTitle) {
    notify({
      type: notifError ? "error" : "success",
      title: notifTitle,
      duration: 3000,
      ignoreDuplicates: true,
    });
  }
};
</script>

<template>
  <button
    type="button"
    class="btn btn-outline-secondary opacity-75"
    aria-label="Compartir producto"
    @click.prevent="shareLink()"
  >
    <span v-if="sharing" class="spinner-grow spinner-grow-sm"></span>
    <i v-else class="bi bi-share"></i>
  </button>
</template>
